import React from 'react';
import { ChannelTypeInternal } from '../../../../../../../data-access/gql-types/graphql';
import { useCover } from '../../../../../hooks/cover';
import { ChannelType } from '../../../../../types';
import { RollerControls } from '../../../../roller-controls';

type CoverChannelControlBoxProps = {
  channel: ChannelType;
  isListItem?: boolean;
};

export const CoverChannelControlBox: React.FC<CoverChannelControlBoxProps> = ({ channel, isListItem }) => {
  const { handleAction } = useCover(channel);

  const handleCoverAction = (type: string) => handleAction(type);

  return <RollerControls handleAction={handleCoverAction} isListItem={isListItem} type={ChannelTypeInternal.Blind} />;
};
